<div class="custom-expander">
  <button
    type="button"
    class="expander-header"
    (click)="toggleExpanded()"
    [attr.aria-expanded]="expanded"
  >
    <span>{{ field['#title'] }}</span>
    <mobi-ui-icon-major
      class="mobi-ui-animation-init"
      [class.mobi-ui-animation-rotate-45-active]="expanded"
      name="plus"
    />
  </button>
  <section
    class="content"
    [class.expanded]="expanded"
    [attr.aria-hidden]="!expanded"
    [attr.aria-label]="field['#title']"
  >
    @for (subfield of getContainerSubfields(field); track $index) {
      <webform-field
        [field]="subfield"
        (onSubmit)="submit()"
        [parentGroup]="parentGroup"
      ></webform-field>
    }
  </section>
</div>
